import { render } from "./UiSpinner.vue?vue&type=template&id=70e1a148"
import script from "./UiSpinner.vue?vue&type=script&lang=js"
export * from "./UiSpinner.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__